import * as z from "zod";

// Editable details for the merchant's donation provider account. Currently maps
// to LiquiDonate's retailer + user registration, but named generically so other
// providers can be added without renaming.
const donationProviderSetupSchema = z.object({
  businessName: z.string().min(1),
  businessPhone: z.string().min(1),
  website: z.string(),
  address: z.object({
    street1: z.string().min(1),
    street2: z.string(),
    city: z.string().min(1),
    state: z.string().min(1),
    zip: z.string().min(1),
    country: z.string().min(1),
  }),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  phone: z.string().min(1),
});

// Pre-fill hints for the setup form, derived from the team record. Unlike a
// submitted form, these are legitimately empty when the team is missing the
// underlying data (e.g. no admin phone), so the field-level constraints from
// the setup schema must NOT apply here.
const donationProviderDefaultsSchema = z.object({
  businessName: z.string(),
  businessPhone: z.string(),
  website: z.string(),
  address: z.object({
    street1: z.string(),
    street2: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    country: z.string(),
  }),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
});

export const getDonationProvider = {
  name: "getDonationProvider" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    defaults: donationProviderDefaultsSchema,
  }),
};

export const setupDonationProvider = {
  name: "setupDonationProvider" as const,
  input: donationProviderSetupSchema,
  output: z.object({ enabled: z.boolean() }),
};
